// extracted by mini-css-extract-plugin
export var circle = "_en-1";
export var exitConfirmationModal = "_en-5";
export var iframe = "_en-0";
export var offline = "_en-3";
export var online = "_en-2";
export var workstationSelectError = "_en-4";